import { ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "./ui/select";

/**
 * Inline "create new exercise" form used inside the ProgramBuilder
 * "Add Exercise" dialog. Extracted verbatim from ProgramBuilder.js to keep
 * behavior identical; all state lives in the parent and is passed via props.
 */
export function NewExerciseForm({
	newExerciseDetails,
	setNewExerciseDetails,
	savingNewExercise,
	onBack,
	onCreate,
	t,
}) {
	return (
		<div className="space-y-5">
			<div className="flex items-center gap-2 mb-2">
				<Button
					variant="ghost"
					size="sm"
					onClick={onBack}
					className="p-1 h-auto"
				>
					<ArrowLeft className="w-4 h-4" />
				</Button>
				<span className="text-sm text-muted-foreground">
					Torna alla selezione
				</span>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				<div className="space-y-2">
					<Label className="label-tactical">Nome Esercizio *</Label>
					<Input
						value={newExerciseDetails.name}
						onChange={(e) =>
							setNewExerciseDetails({
								...newExerciseDetails,
								name: e.target.value,
							})
						}
						className="bg-secondary border-transparent rounded-sm"
						placeholder="Nome dell'esercizio"
						autoFocus
					/>
				</div>

				<div className="space-y-2">
					<Label className="label-tactical">Categoria</Label>
					<Select
						value={newExerciseDetails.category}
						onValueChange={(v) =>
							setNewExerciseDetails({
								...newExerciseDetails,
								category: v,
							})
						}
					>
						<SelectTrigger className="bg-secondary border-transparent rounded-sm">
							<SelectValue />
						</SelectTrigger>
						<SelectContent className="bg-card border-border">
							<SelectItem value="strength">Forza</SelectItem>
							<SelectItem value="cardio">Cardio</SelectItem>
							<SelectItem value="gymnastics">Ginnastica</SelectItem>
							<SelectItem value="olympic">Olimpici</SelectItem>
							<SelectItem value="accessory">Accessori</SelectItem>
						</SelectContent>
					</Select>
				</div>

				<div className="space-y-2 md:col-span-2">
					<Label className="label-tactical">Descrizione (opzionale)</Label>
					<Textarea
						value={newExerciseDetails.description}
						onChange={(e) =>
							setNewExerciseDetails({
								...newExerciseDetails,
								description: e.target.value,
							})
						}
						className="bg-secondary border-transparent rounded-sm min-h-[96px]"
						placeholder="Descrizione dell'esercizio..."
					/>
				</div>

				<div className="space-y-2">
					<Label className="label-tactical">URL Video (opzionale)</Label>
					<Input
						value={newExerciseDetails.video_url}
						onChange={(e) =>
							setNewExerciseDetails({
								...newExerciseDetails,
								video_url: e.target.value,
							})
						}
						className="bg-secondary border-transparent rounded-sm"
						placeholder="https://youtube.com/..."
					/>
				</div>

				<div className="space-y-2">
					<Label className="label-tactical">URL Immagine (opzionale)</Label>
					<Input
						value={newExerciseDetails.image_url}
						onChange={(e) =>
							setNewExerciseDetails({
								...newExerciseDetails,
								image_url: e.target.value,
							})
						}
						className="bg-secondary border-transparent rounded-sm"
						placeholder="https://..."
					/>
				</div>
			</div>

			<div className="flex flex-col-reverse sm:flex-row gap-2 pt-1 sm:justify-end">
				<Button
					variant="outline"
					onClick={onBack}
					className="w-full sm:w-auto sm:min-w-[160px] rounded-sm"
				>
					{t("cancel")}
				</Button>
				<Button
					onClick={onCreate}
					disabled={savingNewExercise || !newExerciseDetails.name.trim()}
					className="w-full sm:w-auto sm:min-w-[200px] bg-volt hover:bg-volt/90 rounded-sm"
				>
					{savingNewExercise ? "Salvataggio..." : "Crea e Seleziona"}
				</Button>
			</div>
		</div>
	);
}
